export const CheckIfIsViewScreen = () => {
 const path = document.location.pathname;
 const includesViewWordInPath = path.includes('view');
 const isView = path.split('/')[3] === 'view';
 return includesViewWordInPath && isView;
}